export default "__VITE_ASSET__5dfc0965__"